import {
  StyleProp, StyleSheet, Text, TextStyle, TouchableOpacity,
} from 'react-native';
import React from 'react';
import ArrowSquareOut from '../../assets/icons/ArrowSquareOut.svg';
import { openLink } from '../../utils/linkUtils';

interface IProps {
  linkText: string;
  url: string;
  textStyle: StyleProp<TextStyle>,
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    textDecorationLine: 'underline',
  },
});

export function BreakoutLinkText({
  linkText,
  url,
  textStyle,
}: IProps) {
  const openUrl = () => {
    openLink(url).catch(() => { /* ignored */ });
  };

  return (
    <TouchableOpacity
      style={styles.container}
      onPress={openUrl}
    >
      <Text style={[textStyle, styles.text]}>{ linkText }</Text>
      <ArrowSquareOut />
    </TouchableOpacity>
  );
}
